<template>
  <section class='leaveStu'>
    <Row>
      <Breadcrumb>
        <BreadcrumbItem>媒体发布</BreadcrumbItem>
        <BreadcrumbItem>知识竞赛</BreadcrumbItem>
      </Breadcrumb>
    </Row>
    <Row xs="20" sm="16" md="12" lg="8">

      <Col span='4'>
      <Input v-model="searchParam.name" placeholder="标题" />
      </Col>

      <Col span='1'>
      <Button type="info" @click='searchData'>查询</Button>
      </Col>
      <ul class='conheadRight'>
        <i-button type="error" @click='sModal(-1)'>新增竞赛</i-button>
      </ul>
    </Row>
    <section class='tabelContent'>
      <tablePage border :queryData="queryData" :searchParam='searchParam' :issearch='issearch' @smodal='sModal'>
      </tablePage>
    </section>


    <bemodal :reloadtmp='reloadTmep' :formdata='formData' @reloadModalData='reloadTable'></bemodal>
    <Modal v-model="quModal" width="1080">
      <template #header style="padding:0px;">
        <section class="modalHead">
          <h2>{{ curExam.title }}</h2>
        </section>
      </template>
      <section class="questions">


        <section class="itemcon">
          <Row class="itemTitles">
            <Col span="1" type="flex" justify="space-between">
            <label for=""><b>排序：</b></label>
            <Input type="text" v-model="curQues.sort" placeholder="排序" style="margin-top:8px;"></Input>
            </Col>
            &nbsp;&nbsp;
            <Col span="16" type="flex" justify="space-between">
            <label for=""><b>题目名称：</b></label>
            <Input type="text" v-model="curQues.title" placeholder="题目" style="margin-top:8px;"></Input>
            </Col>
            &nbsp;&nbsp;
            <Col span="2" type="flex" justify="space-between">
            <label for=""><b>来源：</b></label>
            <Input type="text" v-model="curQues.fromremark" placeholder="来源" style="margin-top:8px;"></Input>
            </Col>
            &nbsp;&nbsp;
            <Col span="1" type="flex" justify="space-between">
            <label for=""><b>分数：</b></label>
            <Input type="text" v-model="curQues.cnt" placeholder="分数" style="margin-top:8px;"></Input>
            </Col>
            &nbsp;&nbsp;
            <Col span="2">
            <label for="" v-if="items.length > 0"><b>正确答案：</b></label>
            <Select v-model="curQues.remark" style="margin-top:8px;" v-if="items.length > 0">
              <Option :value="item.prefix" v-for="item in items">{{ item.prefix }}</Option>
            </Select>
            </Col>
          </Row>
          <Row class="itemTitles" style="margin-top:10px;">
            <Col span="24" type="flex" justify="space-between">
            <label for=""><b>提示：</b></label>
            <Input type="textarea" placeholder="提示" v-model="curQues.answertip" style="margin-top:8px;"></Input>
            </Col>
          </Row>
          <Row class="itemTitles" style="margin-top:10px;">
            <Col span="24" type="flex" justify="space-between">
            <label for=""><b>描述：</b></label>
            <Input type="textarea" placeholder="提示" v-model="curQues.describ" style="margin-top:8px;"></Input>
            </Col>
          </Row>
          <section style='margin:20px 0px;'>
            <Row style="margin-bottom:10px;">
              <Col span="1" style="line-height:32px;margin-left:10px;">
              <b>选项</b>
              </Col>
              <Col span="16" style="line-height:32px;margin-left:10px;">
              <b>问题</b>
              </Col>
              <Col span="4" offset="1" style="line-height:32px;margin-left:10px;">
              <b></b>
              </Col>
            </Row>
            <Row v-for="(item, index) in items" :key="index" :label="'Item ' + item.index" style='margin:20px 0px;'>
              <Col span="1" style="line-height:32px;margin-left:10px;">
              {{ item.prefix }}
              </Col>
              <Col span="16">
              <Input type="text" v-model="item.content" placeholder="请输入"></Input>
              </Col>
              <Col span="4" offset="1">
              <Button type="error" @click="handleRemove(index)">删除</Button>
              </Col>
            </Row>
          </section>
          <section style='margin:20px 0px;'>
            <Row>
              <Col span="4">
              <Button type="primary" long @click="handleAdd" icon="plus-round">新增问题</Button>
              </Col>
            </Row>
          </section>
        </section>

      </section>
      <template #footer>
        <section class="footers">
          <section>
            <Button type="error" @click="removeQues(curQues.guid)">删除</Button>
          </section>
          <section>
            <!-- <Button @click="minus">上一题</Button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <Button type="success" @click="add">下一题</Button> -->
            <Button v-for="(item, index) in qulist" :class="[curIndex == index ? 'actBtn' : '']" size="small"
              @click="setIndex(index)">第{{
                index + 1
              }}题</Button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </section>
          <section>
            <Button type="success" @click="addquestion" v-if="curQues.guid">新增</Button>&nbsp;&nbsp;
            <Button type="primary" @click="saveData">保存</Button>
          </section>
        </section>
      </template>
    </Modal>
    <Modal v-model="qulistModal" width="980">
      <template #header style="padding:0px;">
        <section class="modalHead">
          <h2>{{ curExam.title }}</h2>
        </section>
      </template>
      <section class="questions">
        <dl v-for="item in qulist" :key="item.guid">
          <dt><b>{{ item.sort }}.{{ item.title }}</b></dt>
          <dd v-for="items in item.optionList"><span>{{ items.prefix }}</span> {{ items.content }}</dd>
        </dl>
      </section>
      <template #footer>
        <section class="footers">
          <section>
            <!-- <Button type="primary" :disabled="percent != 100">保存</Button> -->
          </section>
        </section>
      </template>
    </Modal>
  </section>
</template>

<script>
import getDates from '../utils/index'
import tablePage from './tablePage'
import bemodal from './formItemNoSch'
export default {
  name: 'newslist',
  components: {
    tablePage,
    bemodal,
  },
  data () {
    return {
      curIndex: 0,// 当前第几题
      curQues: {
        cnt: '',
        sort: '',
        pguid: '',
        guid: '',
        title: '',
        describ: '',
        type: 0,
        remark: '',
        answertip: '',
        fromremark: '',
        optionLists: [],
      },
      qulist: [
        {
          title: '请对历史进行点评',
          score: 10,
          optionLists: [
            { title: '非常好', },
            { title: '好' },
            { title: '一般般' },
            { title: '差' },
          ]
        }
      ],
      qulistModal: false,
      curExam: {
        title: '',
      },
      rightAnswer: 'A',
      queList: [
        [
          {
            title: '',
            type: 0,
            remark: '', // 正确答案
            answertip: '', // 提示
            formremark: '', // 来源
            tip: '',
            sort: '',
          }
        ]
      ],
      items: [
        // {
        //   value: '',
        //   index: 'A',
        //   status: 1
        // }
      ],
      index: 0,
      percent: 10,
      animal: 'A',
      quModal: false,
      smodal: false,
      reloadTmep: -1,
      initformData: [],
      formData: [
        ['questionNew/getId', 'questionNew/save', 'questionNew/delete'],
        [
          {
            type: 'input',
            title: '竞赛名称',
            name: 'title',
            model: '',
            block: true,
          },
          {
            type: 'numberInput',
            title: '排序',
            name: 'sort',
            model: 1,
            block: true,
          },
          {
            type: 'rangetime',
            title: '有效期',
            model: '',
            block: true,
          },
          {
            type: 'numberInput',
            title: '分数',
            name: 'point',
            model: 100,
            block: true,
          },
          {
            type: 'textarea',
            title: '描述',
            name: 'describ',
            model: ''
          },

          {
            type: 'hidden',
            children: [{
              name: 'guid',
              model: ''
            }]
          }
        ]
      ],
      // queryData: ['questionNew/getQueryList',
      queryData: ['questionNew/getQueryList',
        [
          {
            title: '竞赛名称',
            key: 'title',
            width: 300,

          },
          {
            title: '开始时间',
            key: 'sort',
            width: 300,
            align: 'center',
            render: (h, params) => {
              return h('span', params.row.begintime)
            }
          },
          {
            title: '结束时间',
            key: 'sort',
            width: 300,
            align: 'center',
            render: (h, params) => {
              return h('span', params.row.endtime)
            }
          },
          {
            title: '分数',
            key: 'point',
          },
          {
            title: '题库',
            key: 'url',
            render: (h, params) => {
              return h('div', [
                h('div', {
                  style: {
                    margin: '5px 10px',
                    textDecoration: 'underline',
                    color: '#2d8cf0',
                    cursor: 'pointer'
                  },
                  on: {
                    click: () => {
                      this.curExam = params.row
                      console.log(params.row)
                      this.quModal = true
                      this.getSon(params.row.guid)
                    }
                  }
                }, '编辑')
              ]);
            },
          },
          {
            title: '题目详情',
            key: 'url',
            render: (h, params) => {
              return h('div', [
                h('div', {
                  style: {
                    margin: '5px 10px',
                    textDecoration: 'underline',
                    color: '#2d8cf0',
                    cursor: 'pointer'
                  },
                  on: {
                    click: () => {
                      this.curExam = params.row
                      this.qulistModal = true
                      this.getSon(params.row.guid)
                    }
                  }
                }, '预览')
              ]);
            },
          },
          {
            title: '操作',
            slot: 'action',
            width: 100,
            align: 'center',
          }

        ]
      ],
      searchParam: {
        name: '',
        itemid: '',
      },
      issearch: -1,
    }
  },
  mounted () {
    this.initformData = JSON.parse(JSON.stringify(this.formData[1]))
  },
  methods: {
    removeQues (id) {
      var that = this
      if (id) {
        this.$Modal.confirm({
          title: '提示',
          content: '<p>是否确认删除？</p>',
          onOk: () => {
            that.axios.post('questionNewTitle/delete', { id: id }).then(res => {
              console.log(res, 'res--------->')
              that.$Message.info(res.msg)
              that.qulist = that.qulist.filter(function (val, index) {
                return val['guid'] != id
              })
              that.curIndex = 0
              that.setIndex(that.curIndex)
            })
          },
          onCancel: () => {

          }
        });
      } else {
        that.qulist = that.qulist.filter(function (val, index) {
          return index != that.curIndex
        })
        that.curIndex = 0
        that.setIndex(that.curIndex)
      }

    },
    saveData () {
      console.log(this.curQues)
      console.log(this.items)
      var that = this
      if (this.curQues.remark == '') {
        this.$Message.info('请选择正确答案')
        return false;
      }
      if (this.curQues.cnt == '') {
        this.$Message.info('请填写分数')
        return false;
      }
      var items = []
      this.items.map(function (val, index) {
        var obj = {
          guid: val['guid'],
          pguid: that.curQues.guid,
          content: val['content'],
          prefix: val['prefix'],
          status: 1,
          sortby: index + 1
        }
        items.push(obj)
      })
      this.curQues['optionLists'] = JSON.stringify(items)
      var that = this
      var param = this.curQues
      console.log(param, 'param')
      this.axios.post('questionNewTitle/save', param).then(res => {
        console.log(res, 'res--------->')
        that.$Message.info(res.msg)
        that.getSon(that.curExam.guid)
      })
    },
    handleAdd () {
      var letters = ['A', 'B', 'C', 'D', 'E', 'F', 'H']

      this.items.push({
        guid: '',
        pguid: this.curQues.guid,
        content: '',
        prefix: letters[this.index],
        status: 1,
        sortby: this.index
      });
      this.index++;
    },
    handleRemove (index) {
      // this.items[index].status = 0;
      var letters = ['A', 'B', 'C', 'D', 'E', 'F', 'H']
      this.items.splice(index, 1)
      this.items.map(function (val, index) {
        val['index'] = letters[index]
      })
      this.index = this.items.length
    },
    setIndex (idx) {
      this.curIndex = idx
      var curItem = this.qulist[idx]
      this.curQues = {
        cnt: curItem.cnt,
        sort: curItem.sort,
        pguid: curItem.pguid,
        guid: curItem.guid,
        title: curItem.title,
        describ: curItem.describ,
        type: 0,
        remark: curItem.remark,
        answertip: curItem.answertip,
        fromremark: curItem.fromremark,
      }
      this.items = curItem['optionLists']
      console.log(this.curQues, this.items)
    },
    addquestion () {
      var that = this
      that.curQues = {
        cnt: 10,
        sort: this.qulist.length + 1,
        pguid: that.curExam.guid,
        guid: '',
        title: '',
        describ: '',
        type: 0,
        remark: '',
        answertip: '',
        fromremark: '',
        optionLists: [],
      }
      that.items = []
      this.index = 0
      that.qulist.push(that.curQues)
      this.curIndex = this.qulist.length - 1
    },
    getSon (pid) {
      var that = this

      this.axios.get('questionNewTitle/getQueryList',
        { params: { pguid: pid, length: -1 } }
      ).then(res => {
        console.log(res.data.length, 'res--------->')
        res.data.map(function (val, index) {
          val['optionLists'] = val['optionList']
        })
        that.qulist = res.data
        that.curIndex = 0
        if (res.data.length > 0) {
          var curItem = res.data[0]
          that.curQues = {
            cnt: curItem.cnt,
            sort: curItem.sort,
            pguid: pid,
            guid: curItem.guid,
            title: curItem.title,
            describ: curItem.describ,
            type: 0,
            remark: curItem.remark,
            answertip: curItem.answertip,
            fromremark: curItem.fromremark,
          }
          that.items = curItem['optionLists']
          console.log(that.curQues, that.items)
        } else {
          that.curQues = {
            cnt: 10,
            sort: 1,
            pguid: pid,
            guid: '',
            title: '',
            describ: '',
            type: 0,
            remark: '',
            answertip: '',
            fromremark: '',
            optionLists: [],
          }
          that.items = []
        }
      })
    },
    add () {
      if (this.percent >= 100) {
        return false;
      }
      this.percent += 10;
    },
    minus () {
      if (this.percent <= 0) {
        return false;
      }
      this.percent -= 10;
    },
    searchData () {
      this.issearch = Math.random()
    },
    sModal (guid, row) {
      console.log(guid, 'guid', this.formData[0][0])

      if (this.formData[0][0].indexOf('?') > -1) {
        this.formData[0][0] = this.formData[0][0].split('?')[0]
      }
      var _guid = guid == -1 ? -1 : row.guid
      this.formData[0][0] = this.formData[0][0] + '?id=' + _guid
      if (guid == -1) {
        this.formData[1] = JSON.parse(JSON.stringify(this.initformData))
      }
      this.reloadTmep = Math.random()
    },

    reloadTable () {
      this.issearch = Math.random()
    }
  }
}
</script>

<style scoped>
.tabelContent {
  margin-top: 20px;
}

.leaveStu {
  flex: 1;
  padding-right: 25px !important;
  /* overflow: scroll; */
  padding-bottom: 50px;
  padding-top: 20px;
  overflow-x: hidden;
}

.leaveStu .ivu-row:first-of-type {
  margin-top: 5px;
}

.leaveStu .ivu-row {
  margin-top: 20px;
  /* 	overflow:hidden; */
  position: relative;
}

.leaveStu .ivu-col {
  margin-right: 10px;
  /* float:left; */
}

.leaveStu .ivu-col:last-of-type {
  float: left;
  margin-left: 10px;
  /* position:absolute;
		right:0px; */
}

.demo-upload-list {



  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  overflow: hidden;
  margin-right: 4px;
  margin-bottom: 5px;
}

.demo-upload-list img {
  width: 40px;
  height: 40px;
  float: left;
  margin-right: 15px;
}

.demo-upload-list span {
  line-height: 40px;
  font-size: 12px;
  float: left;
}

.demo-upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, .6);
}

.demo-upload-list:hover .demo-upload-list-cover {
  display: block;
}

.demo-upload-list-cover i {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 10px;
  line-height: 40px;

}

#hwSchool {
  position: relative;
}

#hwSchool .ivu-tree {
  position: absolute;
  top: 33px;
  left: 0px;
  background: #fff;
  z-index: 1000;
  width: 300px;
  height: 300px;
  border: 1px solid #dcdee2;
  border-top: 0 none;
  overflow-y: scroll;
  overflow-x: hidden;
  padding-left: 10px;
}

.modalUl {
  width: 100%;
  display: flex;
  justify-content: space-between;


}

.modalUl li {
  list-style: none;

}

.modalUl>li:first-of-type {
  width: 35%;
  height: 100%;
  height: 400px;
  overflow-y: scroll;
  overflow-x: hidden;
}

.modalUl>li:last-of-type {
  flex: 1;
  padding-left: 30px;
}

.treeContent {}

.hwImgCon {
  margin-top: 10px;

}

.hwImgCon img {
  width: 55px;
  height: 55px;
  border-radius: 5px;
}

.conheadRight {
  float: right;
}

cbox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
}

.cbox h3 {
  font-size: 16px;
  color: #1B1F26;
  font-weight: normal;
}

.cbox p {
  font-size: 12px;
  color: #9DA5AD;
}

.cbox .count {
  width: 114px;
  height: 32px;
  background: #FFFFFF;
  border: 1px solid #E6E6E6;
  border-radius: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.questions {
  margin: 0px 0px 10px;
}

.questions dl {
  margin-bottom: 20px;
}

.questions dd {
  margin: 10px 10px;
}

.questions h2 {
  text-align: center;
  margin: 20px 0px;
  font-size: 16px;
  color: #1B1F26;
}

.items {
  border: 1px solid #E6E6E6;
  border-radius: 5px;
  padding: 20px;
}

.items .itemcon {
  margin: 10px;
}

.footers {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.itemTitles {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.actBtn {
  background: #00d186;
  color: #fff;
}
</style>
